/**
 * Generates a random number between 0 and 999999.
 * @returns A number from 0 up to 999999 (inclusive)
 */
export const getNumberId = (): number => Math.floor(Math.random() * 1_000_000);
